import { create, StateCreator } from "zustand";
import { devtools } from "zustand/middleware";
import { UserEvaluation, EvaluationSummary } from "../../../evaluation/models/Evaluation";

type EvaluationState = {
  evaluations: UserEvaluation[];
  evaluationSummaries: EvaluationSummary[];
  currentEvaluation: UserEvaluation | null;
  isLoading: boolean;
  setEvaluations: (evaluations: UserEvaluation[]) => void;
  setEvaluationSummaries: (summaries: EvaluationSummary[]) => void;
  setCurrentEvaluation: (evaluation: UserEvaluation | null) => void;
  setIsLoading: (loading: boolean) => void;
  addEvaluation: (evaluation: UserEvaluation) => void;
  updateEvaluationSummary: (summary: EvaluationSummary) => void;
};

const storeApi: StateCreator<EvaluationState> = (set, get) => ({
  evaluations: [],
  evaluationSummaries: [],
  currentEvaluation: null,
  isLoading: false,
  setEvaluations: (evaluations) => {
    set({ evaluations });
  },
  setEvaluationSummaries: (summaries) => {
    set({ evaluationSummaries: summaries });
  },
  setCurrentEvaluation: (evaluation) => {
    set({ currentEvaluation: evaluation });
  },
  setIsLoading: (loading) => {
    set({ isLoading: loading });
  },
  addEvaluation: (evaluation) => {
    const current = get().evaluations;
    set({ evaluations: [...current, evaluation] });
  },
  updateEvaluationSummary: (summary) => {
    const current = get().evaluationSummaries;
    const index = current.findIndex(s => s.userId === summary.userId && s.date === summary.date);
    
    if (index >= 0) {
      current[index] = summary;
      set({ evaluationSummaries: [...current] });
    } else {
      set({ evaluationSummaries: [...current, summary] });
    }
  },
});

export const useEvaluationStore = create<EvaluationState>()(
  devtools(storeApi, { name: "evaluation-store" })
);